export default "__VITE_ASSET__c504b64d__"